// MWC inherits table constants from cccc
import ccccFrontendRoutesConstants from './cccc';

export default ccccFrontendRoutesConstants;
